<template>
  <div>
    <v-dialog
      v-model="checkListFormVueDialog"
      persistent
      max-width="800"
      content-class="dialog-check-list"
    >
      <v-form
        @submit.prevent="onSave()"
        ref="contractAsset"
        :lazy-validation="true"
        :disabled="isDisable || isLoading"
      >
        <v-card outlined>
          <v-card-title :class="`${isCreate ? 'success':'warning'} white--text justify-between`">
            {{
            isCreate
            ? text.isCreate + text.title
            : isUpdate
            ? text.isUpdate + text.title
            : text.title
            }}
            <v-btn color="white" icon @click="checkListFormVueDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="py-5 overflow-y-auto">
            <v-overlay v-if="isLoading" opacity="1" color="white" absolute>
              <v-progress-circular indeterminate color="green"></v-progress-circular>
            </v-overlay>
            <!-- Content Space -->
            <div v-if="false">
              <label>{{ $t('area.space') }}</label>
              <v-select
                append-icon
                chips
                outlined
                background-color="white"
                :items="getAreas"
                v-model="haveAreas"
                item-value="objectId"
                item-text="name"
                multiple
                disabled
                :no-data-text="$t('noinfo')"
              ></v-select>
            </div>
            <h3 v-if="false">{{ $t('asset.asset_list') }}</h3>
            <div
              v-for="(contractAsset,index) in form.contractAssets"
              :key="index"
              class="asset-box"
            >
              <div class="flex justify-space-between">
                <h4>{{ $t('list_number', {index: index+1}) }}</h4>
                <v-btn
                  color="error"
                  small
                  @click="removeContractAsset(index)"
                  :disabled="form.contractAssets.length <= 1"
                >
                  <v-icon class="me-2">mdi-close</v-icon>
                  {{ $t('delete_list', {index: index+1}) }}
                </v-btn>
              </div>
              <div class="flex">
                <div class="w-100">
                  <label>{{ $t('asset.select_asset') }}</label>
                  <v-autocomplete
                    solo
                    flat
                    background-color="grey lighten-4"
                    :items="assets"
                    v-model="contractAsset.assetId"
                    item-value="id"
                    :item-text="(r) => `${r.name} - ${r.name_en}`"
                    append-outer-icon="mdi-plus"
                    @click:append-outer="showAsset(true, false)"
                    :rules="[rules.required]"
                  >
                    <template v-slot:item="{ item }">
                      <div class="flex items-center justify-between">
                        <div>
                          <div class="text-xs text-gray-400">{{ item.categoryName }}</div>
                          {{ item.name }} -
                          {{ item.name_en }}
                        </div>
                        <v-btn color="warning" icon @click="showAsset(false, true, item)">
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </div>
                    </template>
                  </v-autocomplete>
                </div>
                <div class="ml-10 w-100">
                  <label>{{ $t('asset.asset_price') }}</label>
                  <v-currency-field
                    solo
                    flat
                    background-color="grey lighten-4"
                    v-model="contractAsset.cost"
                    :label="$t('price')"
                    :rules="[rules.required]"
                  />
                </div>
              </div>
              <div class="flex">
                <div class="w-100">
                  <label class="flex justify-space-between">
                    <div>{{ $t('area.space') }}</div>
                    <div>
                      <v-btn
                        color="success"
                        text
                        small
                        @click="contractAsset.areaIds = getAreas.map(a=>a.objectId)"
                        :disabled="!isCreate"
                      >{{ $t('area.select_all_stall') }}</v-btn>
                      <v-btn
                        color="error"
                        text
                        small
                        @click="contractAsset.areaIds = []"
                        :disabled="!isCreate"
                      >{{ $t('area.unselect_all_stall') }}</v-btn>
                    </div>
                  </label>
                  <v-select
                    chips
                    solo
                    flat
                    background-color="grey lighten-4"
                    :items="getAreas"
                    v-model="contractAsset.areaIds"
                    item-value="objectId"
                    item-text="name"
                    multiple
                    :disabled="!isCreate"
                    :rules="[rules.areas]"
                    :no-data-text="$t('noinfo')"
                  ></v-select>
                </div>
                <div class="ml-10 w-100">
                  <label>{{ $t('note') }}</label>
                  <v-text-field
                    :label="$t('note')"
                    solo
                    flat
                    background-color="grey lighten-4"
                    v-model="contractAsset.note"
                  ></v-text-field>
                </div>
              </div>
              <div class="flex align-center">
                <div>{{ $t('asset.asset_image') }}</div>
                <div>
                  <label :for="`file-upload-${index}`" class="load-file-btn">
                    <v-icon color="white" class="me-1" size="20">mdi-paperclip</v-icon>{{ $t('select_image_file') }}
                  </label>
                  <v-file-input
                    :id="`file-upload-${index}`"
                    accept="image/*"
                    @change="uploadImage($event,contractAsset.images)"
                    style="display:none;"
                    v-if="!isUploadImage"
                  ></v-file-input>
                </div>
              </div>
              <div class="my-2" v-if="contractAsset.images && contractAsset.images.length">
                <div
                  v-for="(img, index) in contractAsset.images"
                  :key="img.name"
                  class="flex img-box"
                >
                  <img class="w-full rounded" :src="img.url" />
                  <div class="absolute right-1 top-1">
                    <v-btn
                      color="error"
                      icon
                      @click="contractAsset.images.splice(index, 1)"
                      :disabled="isDisable"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </div>
                </div>
              </div>
              <div v-else class="pl-10 py-5 text-gray-400" style="font-size:16px;">{{ $t('no_image') }}</div>
            </div>
            <div class="flex justify-center">
              <v-btn
                class="mt-2 justify-center"
                color="info"
                @click="addContractAsset()"
                :disabled="isUpdate"
              >
                <v-icon class="me-2">mdi-plus</v-icon>{{ $t('asset.add_asset') }}
              </v-btn>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="mx-2">
            <v-spacer></v-spacer>
            <v-btn color="error" elevation="0" @click="onCancel">
              <v-icon left>mdi-window-close</v-icon>{{ $t('close') }}
            </v-btn>
            <v-btn color="success" elevation="0" type="submit" :disabled="isDisable || isLoading">
              <v-icon left>mdi-circle-outline</v-icon>{{ $t('save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
      <LoadingPercentDialog
        v-model="isLoadingDialog"
        :final="loadingFinal"
        :initial="loadingInitial"
      />
    </v-dialog>
    <asset-form
      v-model="isAsset"
      :isCreate="asset.isCreate"
      :isUpdate="asset.isUpdate"
      :object="asset.object"
      @onSave="getAssets"
    ></asset-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { FileUpload } from "../classes";
import AssetForm from "./AssetForm.vue";
import LoadingPercentDialog from "./LoadingPercentDialog.component";
export default {
  components: { AssetForm, LoadingPercentDialog },
  name: "CheckListFormVue",
  props: {
    value: Boolean,
    objectId: String,
    isDisable: Boolean,
    isUpdate: Boolean,
    isCreate: Boolean,
    haveAreas: Array
  },
  computed: {
    ...mapGetters({
      getAreas: "contract/getAreas",
      assets: "asset/getAssets",
      contractId: "contract/getContractId"
    }),
    checkListFormVueDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    areasIsCan() {
      return this.getAreas.filter(area => {
        return !this.haveAreas.includes(area.objectId);
      });
    }
  },
  watch: {
    value(data) {
      if (this.$refs.contractAsset) this.$refs.contractAsset.resetValidation();
      if (data) {
        this.initData();
      }
    },
    haveAreas(value) {
      this.form.areaIds = value;
    }
  },
  data() {
    return {
      rules: {
        required: value => !!value || this.$t('validate.please_input_data'),
        areas: v => (v && v.length != 0) || this.$t('validate.please_select_stall')
      },
      form: { areaIds: [] },
      text: {},
      isAsset: false,
      asset: {
        isCreate: false,
        isUpdate: false,
        object: {}
      },
      imgUpload: null,
      isLoading: false,
      isUploadImage: false,
      isLoadingDialog: false,
      loadingInitial: 0,
      loadingFinal: 0
    };
  },
  created() {
    this.text = {
      title: this.$t('asset.asset_list'),
      isCreate: this.$t('action_type.add'),
      isUpdate: this.$t('action_type.edit')
    };
  },
  methods: {
    async initData() {
      if (this.haveAreas && this.haveAreas.length) {
        this.form.areaIds = this.haveAreas;
      }
      try {
        if (this.isCreate) {
          this.resetForm();
        } else {
          await this.getContractAsset();
        }
        await this.getAssets();
        this.$emit("onInit");
      } catch (e) {
        console.log(e);
      }
    },
    async saveData() {
      try {
        if (this.isCreate) {
          this.isLoadingDialog = true;
          this.loadingInitial = this.form.contractAssets
            .map(ca => ca.areaIds.length)
            .reduce((partialSum, a) => partialSum + a, 0);
          for (const contractAsset of this.form.contractAssets) {
            for (const areaId of contractAsset.areaIds) {
              let data = {
                areaId,
                contractId: this.contractId,
                assetId: contractAsset.assetId,
                cost: parseFloat(contractAsset.cost),
                images: contractAsset.images,
                note: contractAsset.note
              };
              if (
                contractAsset.assetId &&
                contractAsset.cost &&
                contractAsset.cost > 0
              ) {
                await this.createContractAsset(data);
              }
              this.loadingFinal++;
            }
          }
          this.isLoadingDialog = false;
        } else {
          this.isLoadingDialog = true;
          this.loadingInitial = this.form.contractAssets.length || 0;
          for (const contractAsset of this.form.contractAssets) {
            let data = {
              id: contractAsset.id,
              areaId: contractAsset.areaId,
              contractId: contractAsset.contractId,
              assetId: contractAsset.assetId,
              cost: parseFloat(contractAsset.cost),
              images: contractAsset.images,
              note: contractAsset.note
            };
            if (contractAsset.assetId && contractAsset.cost) {
              await this.updateContractAsset(data);
            }
            this.loadingFinal++;
          }
          this.isLoadingDialog = false;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async onSave() {
      try {
        if (this.$refs.contractAsset.validate()) {
          this.isLoading = true;
          await this.saveData();
          this.checkListFormVueDialog = false;
          this.$emit("onSave");
          this.isLoading = false;
        }
      } catch (e) {
        this.isLoading = false;
        console.log(e);
      }
    },
    onCancel() {
      try {
        this.checkListFormVueDialog = false;
        this.$emit("onCancel", this.form);
      } catch (e) {
        console.log(e);
      }
    },
    async getAssets() {
      try {
        const response = await this.$store.dispatch("asset/getAssets", {
          projectId: this.$route.params.projectId
        });
        return response;
      } catch (e) {
        console.log(e);
      }
    },
    async getContractAsset() {
      try {
        this.isLoading = true;
        let response = await this.$store.dispatch(
          "contractAsset/getContractAsset",
          {
            id: this.objectId
          }
        );
        response.areaIds = [response.areaId];
        this.form.contractAssets = [response];
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        console.log(e);
      }
    },
    async createContractAsset(data) {
      try {
        this.isLoading = true;
        const response = await this.$store.dispatch(
          "contractAsset/createContractAsset",
          data
        );
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
        console.log(e);
      }
    },
    async updateContractAsset(data) {
      try {
        if (this.$refs.contractAsset.validate()) {
          this.isLoading = true;
          const response = await this.$store.dispatch(
            "contractAsset/updateContractAsset",
            data
          );
          this.isLoading = false;
          return response;
        }
      } catch (e) {
        this.isLoading = false;
        console.log(e);
      }
    },
    async uploadImage(e, to = []) {
      try {
        if (e) {
          this.$toast.show({
            color: "warning",
            content: this.$t('upload.uploading_image')
          });
          this.isUploadImage = true;
          const file = await FileUpload.upload(e);
          this.isUploadImage = false;
          to.push(file);
          this.$toast.show({
            color: "success",
            content: this.$t('upload.upload_image_finish')
          });
        }
      } catch (e) {
        this.isUploadImage = false;
        this.$toast.show({
          color: "error",
          content: this.$t('upload.during_upload_image_error')
        });
        console.log(e);
      }
    },
    showAsset(isCreate, isUpdate, object) {
      this.isAsset = true;
      this.asset.isCreate = isCreate;
      this.asset.isUpdate = isUpdate;
      this.asset.object = object;
    },
    resetForm() {
      // reset ref=file
      this.imgUpload = null;
      this.form = {
        contractAssets: [
          {
            areaIds:
              this.haveAreas && this.haveAreas.length
                ? this.haveAreas
                : this.getAreas.map(a => a.objectId) || [],
            assetId: "",
            cost: null,
            note: "",
            images: []
          }
        ],
        areaIds: [],
        assetId: "",
        assetIds: [],
        cost: null,
        note: "",
        images: []
      };
    },
    addContractAsset() {
      this.form.contractAssets.push({
        areaIds:
          this.haveAreas && this.haveAreas.length
            ? this.haveAreas
            : this.getAreas.map(a => a.objectId) || [],
        assetId: "",
        cost: null,
        note: "",
        images: []
      });
    },
    removeContractAsset(index) {
      this.form.contractAssets.splice(index, 1);
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-check-list.v-dialog .v-card__text::v-deep {
  height: 600px;
  max-height: calc(90vh - 65px - 64px);
}
.asset-box {
  border: 1px solid #5555552f;
  border-radius: 10px;
  padding: 15px;
  margin: 10px 0 15px 0;
}
.load-file-btn {
  margin-left: 15px;
  background: var(--v-info-base);
  padding: 5px 10px;
  color: white;
  border-radius: 5px;
  cursor: pointer;
}
.img-box {
  max-width: 49%;
  position: relative;
  display: inline-flex;
  padding: 5px;
}
</style>
